import { computed, inject, Injectable, Signal } from '@angular/core';

import { UserInvitationCacheService } from '@core/tellent-logic';
import { InviteMethod, StepDefinition, UserInvitationFlow } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class InvitationFlowStepService {
  private readonly userInvitationCacheService = inject(UserInvitationCacheService);

  public flowStepMap: Signal<Record<UserInvitationFlow, StepDefinition[]>> = computed(() => ({
    [UserInvitationFlow.InviteMemberBasic]: [
      { step: 'add_member', initialData: { flowType: UserInvitationFlow.InviteMemberBasic } },
      { step: 'assign_members_to_jobs', canMatch: data => !!data.displayAutj },
      { step: 'member_added_success' },
    ],
    [UserInvitationFlow.InviteMemberAdvanced]: [
      {
        step: 'add_member_new',
        initialData: { flowType: UserInvitationFlow.InviteMemberAdvanced },
      },
      {
        step: 'assign_members_to_jobs',
        canMatch: data => data.inviteMethod === InviteMethod.Email && !!data.displayAutj,
      },
      { step: 'download_credentials', canMatch: data => data.inviteMethod === InviteMethod.Login },
      { step: 'subdomain_information', canMatch: data => data.inviteMethod === InviteMethod.Login },
      { step: 'member_added_success' },
    ],
    [UserInvitationFlow.AddEmployeeForPreonboarding]: [
      {
        step: 'journey_promo_dialog',
        canMatch: () => this.displayJourneysPromoDialog(),
      },
      { step: 'add_employee_for_preonboarding' },
    ],
    [UserInvitationFlow.AddEmployeeWithoutAccess]: [
      { step: 'add_employee_without_access' },
      { step: 'member_added_success' },
      {
        step: 'journey_promo_dialog',
        canMatch: data => this.displayJourneysPromoDialog() && !!data.startPreonboarding,
      },
    ],
  }));

  private displayJourneysPromoDialog(): boolean {
    return this.userInvitationCacheService.getJourneysPromoDialogFlag() !== true;
  }
}
